import type { ShadowOrganization } from "@sitescene/types";

import { createContext } from "react";

export interface OrgSelectionValue {
	/** Load failure, so the shell can say "couldn't load" rather than "none assigned" */
	error: Error | null;
	isLoading: boolean;
	organizations: ShadowOrganization[];
	selected: null | ShadowOrganization;
	selectOrg: (orgCode: string) => void;
}

export const OrgSelectionContext = createContext<null | OrgSelectionValue>(
	null,
);

/** localStorage key holding the last organization this viewer picked. */
export const ORG_STORAGE_KEY = "shadow-realm:selected-org";
